import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { nodeEnv } from 'environment'

import { useAppSelector } from 'redux/hooks'
import { selectMaindeckCards, selectCommanderCards, useCanEditDeck } from 'redux/deck/selectors'
import { useComponentDidMount } from 'hooks/componentDidMount'

import {
  hideTagRecommendationsKeyForNow,
  permanentlyHideTagRecommendationsKey,
} from 'components/accountSettingsPage/BrowserSpecificSiteSettings'

const REMINDER_MENU_DELAY = nodeEnv === 'production' ? 30000 : 10

export const useShowTagRecsMenu = () => {
  const canEditDeck = useCanEditDeck()

  const [allowMenuToShow, setAllowMenuToShow] = useState<boolean>(false)
  const [showMenu, setShowMenu] = useState<boolean>(false)

  const mainDeckCards = useAppSelector(selectMaindeckCards)
  const commanderCards = useAppSelector(selectCommanderCards)
  const deckTags = useAppSelector(state => state.deck.deckTags)
  const legalityStatus = useAppSelector(state => state.deck.legalityStatus)
  const [{ tbHideTagRecommendationsForNow, tbPermanentlyHideTagRecommendations }, setCookies] = useCookies([
    hideTagRecommendationsKeyForNow,
    permanentlyHideTagRecommendationsKey,
  ])
  const isMounted = useComponentDidMount()

  // We don't want to reminder menu popping up too quickly. This delay prevents that, no matter how many
  // changes are made to the deck.
  useEffect(() => {
    // If deck tags are set when the page loads, never show the reminder menu even if the conditions for it are met
    if (deckTags.length) return

    // Never show menu if the user cannot edit the deck
    if (!canEditDeck) return

    setTimeout(() => setAllowMenuToShow(true), REMINDER_MENU_DELAY)
  }, [])

  // If the menu is ever closed for any reason after it opens, hide it for the session
  useEffect(() => {
    if (!showMenu && isMounted)
      setCookies(hideTagRecommendationsKeyForNow, true, {
        path: '/',
      })
  }, [showMenu])

  useEffect(() => {
    if (!allowMenuToShow) return

    if (tbHideTagRecommendationsForNow === 'true') return setShowMenu(false)
    if (tbPermanentlyHideTagRecommendations === 'true') return setShowMenu(false)
    if (!isMounted) return setShowMenu(false)
    if (legalityStatus !== 'legal') return setShowMenu(false)
    if (deckTags.length !== 0) return setShowMenu(false)

    setShowMenu(true)
  }, [mainDeckCards, commanderCards, tbHideTagRecommendationsForNow, deckTags, legalityStatus])

  return showMenu
}
